import { render } from "./LabelView.vue?vue&type=template&id=ef1392c6&scoped=true"
import script from "./LabelView.vue?vue&type=script&lang=js"
export * from "./LabelView.vue?vue&type=script&lang=js"

import "./LabelView.vue?vue&type=style&index=0&id=ef1392c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1392c6"]])

export default __exports__